import { useMemo } from 'react'

import { getCoverLevelOption, Quote } from '../domain'
import { getCoverLevelConfig, ProductConfig } from '../state/configuration'

export const useCoverLevelOption = (quote: Quote | undefined, product: ProductConfig) =>
  useMemo(() => {
    const coverLevelOption = getCoverLevelOption(quote)
    const coverLevelConfig = getCoverLevelConfig(product, coverLevelOption?.coverLevel)

    return { coverLevelOption, coverLevelConfig }
  }, [quote, product])
